import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';

const KeyboardShortcuts: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Ctrl+Shift+A (Admin)
      if (event.ctrlKey && event.shiftKey && event.key === 'A') {
        event.preventDefault();
        event.stopPropagation();
        
        // Navigate to admin login
        navigate('/admin/login');
        
        // Show notification
        setNotificationMessage('🔑 Redirecting to Admin Panel...');
        setShowNotification(true);
        
        // Log for debugging
        console.log('🔑 Admin panel access activated!');
      }
      
      // Check for Ctrl+Shift+U (User Login)
      if (event.ctrlKey && event.shiftKey && event.key === 'U') {
        event.preventDefault();
        event.stopPropagation();
        
        // Navigate to user login
        navigate('/login');
        
        // Show notification
        setNotificationMessage('👤 Redirecting to User Login...');
        setShowNotification(true);
        
        // Log for debugging
        console.log('👤 User login access activated!');
      }
    };

    // Add event listener
    document.addEventListener('keydown', handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  return (
    <Snackbar
      open={showNotification}
      autoHideDuration={3000}
      onClose={handleCloseNotification}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleCloseNotification} 
        severity="info" 
        sx={{ width: '100%' }}
      >
        {notificationMessage}
      </Alert>
    </Snackbar>
  );
};

export default KeyboardShortcuts;